exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#help-modal[data-v-5c166511]{width:400px;background-color:#fff;color:#465978;border:.5px solid #465978;position:absolute;top:10%;left:50%;margin-left:-200px;z-index:1}h2[data-v-5c166511]{width:80%;margin:0 auto;margin-bottom:30px;margin-top:15px;font-weight:700;text-align:center}.help-modal-player[data-v-5c166511]{display:block;margin:0 auto}.input-group[data-v-5c166511]{width:65%;margin:0 auto}.invalid-input[data-v-5c166511]{background-color:#fcc}p[data-v-5c166511]{width:65%;margin:0 auto;font-size:12px;margin-bottom:15px}.policy-link[data-v-5c166511]{text-decoration:underline}.btn[data-v-5c166511]{width:30%;margin:0 auto;background-color:#465978;color:#fff;font-size:22px;font-weight:700;margin-bottom:30px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c166511","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/HelpModal.vue
// module id = 185
// module chunks = 0